import React, { Component } from 'react';
import Plx from 'react-plx';

import './App.css';

import Top from './components/Drawings/Clapper/Top';
import Bottom from './components/Drawings/Clapper/Bottom';
import Bird from './components/Bird';
import WeDo from './components/WeDo';
import Down from './components/Drawings/Down';


import { speed } from './Config';

const iconPlx = [
  {
    start: `${0 * speed}vh`,
    end: `${5 * speed}vh`,
    easing: [0.25, 0.1, 0.6, 1.5],
    properties: [
      {
        startValue: 0,
        endValue: 1,
        property: 'scale',
      },
      {
        startValue: 90,
        endValue: 0,
        unit: 'deg',
        property: 'rotate',
      }
    ]
  },
  {
    start: `${2 * speed}vh`,
    end: `${4 * speed}vh`,
    easing: [0.25, 0.1, 0.6, 1.5],
    properties: [
      {
        startValue: 0,
        endValue: -10,
        unit: 'vh',
        property: 'translateY',
      },
    ]
  },
  {
    start: `${4 * speed}vh`,
    end: `${5 * speed}vh`,
    easing: [0.25, 0.1, 0.6, 1.5],
    properties: [
      {
        startValue: -10,
        endValue: -0.7,
        unit: 'vh',
        property: 'translateY',
      },
    ]
  },
  {
    start: `${4.5 * speed}vh`,
    end: `${5 * speed}vh`,
    easing: [0.25, 0.1, 0.6, 1.5],
    properties: [
      {
        startValue: '#000000',
        endValue: '#FFFFFF',
        property: 'color',
      }
    ]
  },
  {
    start: `${5.5 * speed}vh`,
    end: `${7 * speed}vh`,
    properties: [
      {
        startValue: 1,
        endValue: 2,
        property: 'scale',
      },
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
    ]
  },
];

const clapperTop = [
  {
    start: `${2 * speed}vh`,
    end: `${4 * speed}vh`,
    easing: [0.25, 0.1, 0.6, 1.5],
    properties: [
      {
        startValue: 0,
        endValue: -20,
        property: 'rotate',
      },
      {
        startValue: 0,
        endValue: -2,
        unit: '%',
        property: 'translateX',
      },
    ]
  },
  {
    start: `${4 * speed}vh`,
    end: `${5 * speed}vh`,
    easing: [0, 0, 0.6, 1, 1.5],
    properties: [
      {
        startValue: -20,
        endValue: 0,
        property: 'rotate',
      },
      {
        startValue: -2,
        endValue: 0,
        unşt: '%',
        property: 'translateX',
      },
    ]
  },
]

const background = [
  {
    start: `${4.7 * speed}vh`,
    end: `${5 * speed}vh`,
    easing: [0.25, 0.1, 0.8, 1.5],
    properties: [
      {
        startValue: "#FFFFFF",
        endValue: "#263238",
        property: 'backgroundColor',
      },
    ]
  },
];

const down = [
  {
    start: `${0 * speed}vh`,
    end: `${0.25 * speed}vh`,
    easing: [0.25, 0.1, 0.8, 1.5],
    properties: [
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
    ]
  },
];

class App extends Component {
  render() {
    return (
      <div className="App">
        <Plx
          className="plx-background"
          parallaxData={ background }
        />
        <div
          className="fixed-wrapper"
        >
          <Bird />
          <Plx
            className="plx-clapper-icon"
            parallaxData={ iconPlx }
            animateWhenNotInViewport={ true }
          >
            <Plx
              className="plx-clapper-top"
              parallaxData={ clapperTop }
            >
              <Top
                className="clapper_top"
              />
            </Plx>
            <Bottom />
          </Plx>
        </div>
        <WeDo />
        <div className="app-down-wrapper" >
          <Plx
            className="app-down"
            parallaxData={down}
          >
            <Down />
          </Plx>
        </div>
      </div>
    );
  };
};

export default App;
